// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarInfoDescription__container-b8ab40 {
  margin: 8px 0;
}

.CalendarInfoDescription__description-b9b1db {
  color: var(--base-110);
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  display: inline;
}

.CalendarInfoDescription__title-a0148b {
  font: var(--font-subtitle-4);
  color: var(--base-80);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Info/CalendarInfoDescription/CalendarInfoDescription.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,eAAA;AACF;;AAEA;EACE,4BAAA;EACA,qBAAA;EACA,8CAAA;AACF","sourcesContent":[".container {\n  margin: 8px 0;\n}\n\n.description {\n  color: var(--base-110);\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  display: inline;\n}\n\n.title {\n  font: var(--font-subtitle-4);\n  color: var(--base-80);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CalendarInfoDescription__container-b8ab40`,
	"description": `CalendarInfoDescription__description-b9b1db`,
	"title": `CalendarInfoDescription__title-a0148b`
};
module.exports = ___CSS_LOADER_EXPORT___;
